const layoutEvents = ["scroll", "resize", "orientationChange"];
import debounce from "@/utils/debounce";

export default class AttachablePanel {
  element;
  #editor;
  #hidden;
  #options;

  #closeButton; // not used unless we add one with #options.showCloseButton

  #rawLayoutHandler;
  #layoutHandler; // debounced

  constructor(
    editor,
    element,
    options = {
      hideNextButton: true,
      showCloseButton: false,
      onClose: () => {},
    },
  ) {
    this.element = element;
    this.#editor = editor;
    this.#hidden = true;
    this.#options = options;
  }

  attach() {
    const { style } = this.element;

    this.#attachLayoutHandlers();

    style.position = "absolute";
    style.zIndex = "1000";
    style.overflow = "auto";
    style.backgroundColor = "#ffffff";
    style.padding = "1rem";

    this.hide();
  }

  detach() {
    this.#detachLayoutHandlers();
  }

  hide() {
    this.element.classList.add("d-none");
    this.#showNextButton();

    this.#hidden = true;
  }

  show() {
    this.#hidden = false;

    this.element.classList.remove("d-none");
    this.#showCloseButton();
    this.#hideNextButton();

    // some things get reset whenever flow changes, so we delegate all show stuff to the layout handler.
    this.#rawLayoutHandler();
  }

  #basketButtonsContainer() {
    return this.#printessContainer().querySelector(
      ".bc-panel-basket-simple > div:last-of-type",
    );
  }

  #nextButton() {
    // This is pretty hacky.
    return this.#basketButtonsContainer().querySelector(
      "[action='save\+basket']",
    );
  }

  #hideNextButton() {
    if (!this.#options.hideNextButton) return;

    const nextButton = this.#nextButton();
    if (!nextButton) return;

    nextButton.style.display = "none";
  }

  #showCloseButton() {
    if (!this.#options.showCloseButton) return;

    let buttonContainer = this.#closeButton;

    if (!buttonContainer) {
      this.#closeButton = buttonContainer = document.createElement("div");
      buttonContainer.size = "md";
      buttonContainer.label = "×";

      const actualButton = document.createElement("button");

      actualButton.classList.add(
        "bc-button",
        "solid",
        "md",
        "solid",
        "full-width",
        "half-height",
        "close-button",
      );
      actualButton.innerHTML = "&times;";

      buttonContainer.append(actualButton);
      buttonContainer.addEventListener("click", this.#handleClose.bind(this));
    }
    const nextButton = this.#nextButton();
    if (!nextButton) return;
    nextButton.style.flex = "1";

    const container = this.#basketButtonsContainer();
    container.style.display = "flex";
    container.style.flexDirection = "row";
    container.style.justifyContent = "center";

    this.#basketButtonsContainer().append(buttonContainer);
  }

  #handleClose() {
    if (this.#closeButton) {
      this.#closeButton.remove();
    }

    this.#options.onClose();
  }

  #showNextButton() {
    if (!this.#options.hideNextButton) return;

    const nextButton = this.#nextButton();
    if (!nextButton) return;

    nextButton.style.display = "";
  }

  #attachLayoutHandlers() {
    this.#rawLayoutHandler ||= this.#layoutHandlerBuilder.bind(this);
    this.#layoutHandler ||= debounce(this.#rawLayoutHandler, 100);

    layoutEvents.forEach((event) => {
      window.addEventListener(event, this.#layoutHandler);
    });
  }

  #detachLayoutHandlers() {
    if (!this.#layoutHandler) return;

    layoutEvents.forEach((event) => {
      window.removeEventListener(event, this.#layoutHandler);
    });
  }

  #layoutHandlerBuilder() {
    if (this.#hidden) return;

    const container = this.#printessContainer();
    const propertiesPanel = container.querySelector("bc-panel-properties");
    const pagesPanel = container.querySelector("bc-panel-pages-default");
    console.debug("propertiesPanel", propertiesPanel);
    console.debug("pagesPanel", pagesPanel);

    const rects = [];
    if (propertiesPanel) rects.push(propertiesPanel.getBoundingClientRect());
    if (pagesPanel) rects.push(pagesPanel.getBoundingClientRect());

    const minTop = Math.min(...rects.map((r) => r.top));
    const minLeft = Math.min(...rects.map((r) => r.left));
    const maxRight = Math.max(...rects.map((r) => r.right));
    const maxBottom = Math.max(...rects.map((r) => r.bottom));

    const width = maxRight - minLeft;
    const height = maxBottom - minTop;

    const { style } = this.element;
    const main = this.element.closest("main");

    const mainRect = main?.getBoundingClientRect() ?? { top: 0, left: 0 };

    style.top = `${(minTop) - mainRect.top}px`;
    style.left = `${(minLeft) - mainRect.left}px`;
    style.width = `${width}px`;
    // style.height = `${height}px`;
    style.minHeight = `${height}px`;

    this.element.classList.remove("d-none");
  }

  #printessContainer() {
    return this.#editor.ui.shadowRoot;
  }
}
